import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { optimizeImageUrlFillRectangle, optimizeImageUrlFillSquare } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import { FiniteCarouselBase } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Carousel/ByType/FiniteCarouselBase";
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { PillStyles } from "@faire/retailer/components/LayoutElementRenderer/styles/PillStyles";
export var SearchPills = function() {
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, onItemClick = _React_useContext.onItemClick, requestId = _React_useContext.requestId;
    var isSSR = useIsSSR();
    var renderItem = function(item, index) {
        if (!item.query || !item.image || !item.cta_link) {
            return null;
        }
        var isCountryFlag = item.image.tags.length > 0 && item.image.tags.includes("country_flag_image");
        var imageUrl = isCountryFlag ? optimizeImageUrlFillRectangle(item.image, isSSR, PillStyles.COUNTRY_FLAG_WIDTH, PillStyles.COUNTRY_FLAG_HEIGHT, {
            ignoreResizeTag: true
        }) : optimizeImageUrlFillSquare(item.image, isSSR, PillStyles.SQUARE_DIMENSION, {
            ignoreResizeTag: true
        });
        var onClick = function() {
            if (layoutElement.on_click_event_name && item.query) {
                var _layoutElement_on_click_event_name;
                onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId, item.query);
            }
        };
        return /*#__PURE__*/ _jsx(React.Fragment, {
            children: /*#__PURE__*/ _jsxs(PillStyles.Pill, {
                linkTo: item.cta_link,
                onClick: onClick,
                $isCountryFlag: isCountryFlag,
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: imageUrl,
                        alt: item.query,
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: item.query
                    })
                ]
            })
        }, "".concat(item.query, "_").concat(index));
    };
    var getItems = function() {
        return layoutElement.layout_element_data.map(function(elementData) {
            return elementData.search_query_tile;
        }).filter(isNotUndefined);
    };
    var items = getItems();
    return /*#__PURE__*/ _jsx(FiniteCarouselBase, {
        renderItem: renderItem,
        items: items,
        rows: items.length / 4,
        itemGap: 16,
        shouldHideRightButton: true
    });
};
